export default __webpack_public_path__ + "static/media/WindCopec.4b76f18b.svg";